import { render } from "./ClosedDepartment.vue?vue&type=template&id=0e742fec"
import script from "./ClosedDepartment.vue?vue&type=script&lang=js"
export * from "./ClosedDepartment.vue?vue&type=script&lang=js"

import "./ClosedDepartment.vue?vue&type=style&index=0&id=0e742fec&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__